// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jJvo","col":"styles_col__2MUzN"};